<template>
  <component
    v-bind="$attrs"
    :is="elm"
    class="pmw-link"
    @click="$emit('click', $event)"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'PmwLink',

  props: {
    elm: {
      type: String,
      default: 'a'
    }
  }
}
</script>

<style lang="scss" scoped>
.pmw-link {
  @include pmw-reset-button;
  color: pmw-colors('blue-100');
  text-decoration: underline;
}
</style>
